<template>
  <div>
    <b-form-checkbox
      v-model="rowsSelected"
      @change="selectRows"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import { Events } from '@ag-grid-enterprise/all-modules'

export default Vue.extend({
    data() {
        return {
            rowsSelected: false
        }
    },
    mounted() {
        this.params.api.addEventListener('selectionChanged', this._loadRowsSelected)
        this.params.api.addEventListener('paginationChanged', this._loadRowsSelected)
    },
    methods: {
        _loadRowsSelected() {
            const renderedRows = this.params.api.getRenderedNodes()
            this.rowsSelected = renderedRows.length && renderedRows.every(row => row.selected)
        },
        selectRows(checked) {
            const rowCount = this.params.api.getDisplayedRowCount()
            const lastGridIndex = rowCount - 1
            const currentPage = this.params.api.paginationGetCurrentPage()
            const pageSize = this.params.api.paginationGetPageSize()
            const startPageIndex = currentPage * pageSize
            let endPageIndex = (currentPage + 1) * pageSize - 1
            if (endPageIndex > lastGridIndex) {
                endPageIndex = lastGridIndex
            }
            for (let index = startPageIndex; index <= endPageIndex; index++) {
                // selects without dispatch any event (suppressFinishActions to true)
                this.params.api.getDisplayedRowAtIndex(index).setSelected(checked, false, true)
            }

            // TODO: when typescript migrating -> event type is SelectionChangedEvent
            // Emits once an event to indicate the selection action
            const event = {
                type: Events.EVENT_SELECTION_CHANGED,
                api: this.params.api,
                columnApi: this.params.columnApi
            }
            this.params.api.dispatchEvent(event)
        }
    }
})

</script>
